import { ChangeEvent, useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
// import dayjs, { Dayjs } from "dayjs";
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomButton, CustomInput } from '../../../shared/uiComponents';
import DeleteAllocation from './deleteAllocation';
// import { TimeInputsWrapper } from "../Reports/helpers";

import { DispatchProperties } from '../../../redux/store';
import { CreateUserSessionAllocationProperties } from '../../../redux/API/userAPIProperties';
import {
	createUserSessionAllocation,
	getUserActiveAllocations,
	updateUserSessionAllocation,
} from '../../../redux/State/userSlice';

const Content = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { userId } = useParams();

	// const [startDateValue, setStartDateValue] = useState<Dayjs | null>(null);
	// const [endDateValue, setEndDateValue] = useState<Dayjs | null>(null);
	const [hoursPerMonth, setHoursPerMonth] = useState<number>(0);
	const [loading, setLoading] = useState(false);
	const [loadingAllocation, setLoadingAllocation] = useState(true);
	const [hasActiveAllocation, setHasActiveAllocation] = useState(false);
	const [allocationId, setAllocationId] = useState<string | null>(null);

	const handleSave = () => {
		if (!hoursPerMonth || !userId) return;
		setLoading(true);

		const data: CreateUserSessionAllocationProperties = {
			// startDate: dateNormalizer(startDateValue),
			// endDate: dateNormalizer(endDateValue),
			hoursPerMonth,
			userId,
			sessionType: 9,
			frequency: 1,
		};
		dispatch(createUserSessionAllocation(data))
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				dispatch(getUserActiveAllocations(userId));
				onClose();
			})
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	};

	const handleUpdate = () => {
		if (!hoursPerMonth || !userId || !allocationId) return;
		setLoading(true);

		const data: CreateUserSessionAllocationProperties = {
			// startDate: dateNormalizer(startDateValue),
			// endDate: dateNormalizer(endDateValue),
			hoursPerMonth,
			userId,
			sessionType: 9,
			frequency: 1,
		};
		dispatch(updateUserSessionAllocation({ id: allocationId, data }))
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				dispatch(getUserActiveAllocations(userId));
				onClose();
			})
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	};

	// const startDateHandler = (date: Dayjs | null) => {
	//   setStartDateValue(date);
	// };

	// const endDateHandler = (date: Dayjs | null) => {
	//   setEndDateValue(date);
	// };

	const hoursPerMonthHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.valueAsNumber;
		if (value < 0) return;
		setHoursPerMonth(value);
	};

	useEffect(() => {
		if (!userId) return;
		dispatch(getUserActiveAllocations(userId))
			.then(unwrapResult)
			.then((response) => {
				setLoadingAllocation(false);
				const currentAllocation = response.find((allocation) => allocation.isActive);
				setHasActiveAllocation(Boolean(currentAllocation));
				if (!currentAllocation) return;
				// setStartDateValue(dayjs(currentAllocation.startDate));
				// setEndDateValue(dayjs(currentAllocation.endDate));
				setHoursPerMonth(currentAllocation.hoursPerMonth);
				setAllocationId(currentAllocation.id);
			})
			.catch(errorNormalizer);
	}, [userId, dispatch]);

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			{/* <TimeInputsWrapper>
        <Picker.CustomDate label="Start Date" value={startDateValue} onChange={startDateHandler} />

        <Picker.CustomDate
          label="End Date"
          value={endDateValue}
          onChange={endDateHandler}
          disablePast={true}
        />
      </TimeInputsWrapper> */}

			<CustomInput
				label="Hours per month"
				type="number"
				value={hoursPerMonth}
				onChange={hoursPerMonthHandler}
				className="marginBottom16"
				disabled={loading || loadingAllocation}
			/>

			<Stack direction="row" justifyContent="flex-end" alignItems="center" gap="12px" flexWrap="wrap" alignSelf="stretch" className="marginTop8">
				{hasActiveAllocation && <DeleteAllocation onClose={onClose} allocationId={allocationId} userId={userId} disabled={loading || loadingAllocation} />}
				<Stack direction="row" justifyContent="flex-end" alignItems="center" gap="12px" flexWrap="wrap" alignSelf="stretch">
					<CustomButton title="Cancel" onClick={onClose} buttonType="secondaryGray" disabled={loading} />
					<CustomButton
						title={hasActiveAllocation ? 'Save changes' : 'Save'}
						onClick={hasActiveAllocation ? handleUpdate : handleSave}
						loading={loading}
						disabled={loadingAllocation || !Number.isFinite(hoursPerMonth) || hoursPerMonth <= 0 || !userId}
					/>
				</Stack>
			</Stack>
		</div>
	);
};

export default Content;
